import { useEffect } from 'react'

import { Layout } from '../../components'
import { DashboardPanel } from '../../components/panels'
import { DRAWER_KEYS } from '../../store/constants'

import AuthPage from './AuthPage'

/**
 * @description Renders the Dashboard page.
 * It renders the AppBar, Drawer, and PlanGroupsPanel components within the AuthPage component.
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered DashboardPage component.
 */
const DashboardPage = () => {

    useEffect(() => {
        document.title = 'Dashboard | LCD'
    }, [])

    return (
        <AuthPage>
            <Layout selectedKey={DRAWER_KEYS.DASHBOARD} >
                <DashboardPanel />
            </Layout>
        </AuthPage>
    )
}

export default DashboardPage